import { render, staticRenderFns } from "./zfbPay.vue?vue&type=template&id=56fca0a9&scoped=true"
import script from "./zfbPay.vue?vue&type=script&lang=js"
export * from "./zfbPay.vue?vue&type=script&lang=js"
import style0 from "./zfbPay.vue?vue&type=style&index=0&id=56fca0a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fca0a9",
  null
  
)

export default component.exports